import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public $ready = new BehaviorSubject<boolean>(false);

  constructor() {
    const interval = setInterval(() => {
      if (localStorage && (localStorage.remove || localStorage.removeItem)) {
        this.$ready.next(true);
        clearInterval(interval);
      }
    }, 100);
  }

  public set(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public get(key: string) {
    return localStorage.getItem(key);
  }

  public remove(key: string) {
    if (localStorage.remove) {
      localStorage.remove(key);
    } else if (localStorage.removeItem) {
      localStorage.removeItem(key);
    }
  }

  public clear() {
    localStorage.clear();
  }

}
